import {
  APPLY_CHUNK_SIZE,
  nameTranslationsImportService,
  type ApplyRow,
  type ApplyRowResult,
} from "../../../api/nameTranslationsImport.service.js";

export type ChunkedApplyOutcome = {
  results: ApplyRowResult[];
  failure: string | null;
};

// Resolves rather than throws: a failed chunk stops the run, but every result
// the earlier chunks returned is kept for the results CSV.
export async function runChunkedApply(
  rows: ApplyRow[],
  onProgress: (done: number, total: number) => void,
): Promise<ChunkedApplyOutcome> {
  const results: ApplyRowResult[] = [];
  onProgress(0, rows.length);

  for (let start = 0; start < rows.length; start += APPLY_CHUNK_SIZE) {
    const chunk = rows.slice(start, start + APPLY_CHUNK_SIZE);
    try {
      const response = await nameTranslationsImportService.apply(chunk);
      results.push(...response.results);
    } catch (applyError) {
      const message = applyError instanceof Error ? applyError.message : String(applyError);
      return {
        results,
        failure:
          `Stopped after ${results.length.toLocaleString()} of ` +
          `${rows.length.toLocaleString()} rows: ${message} ` +
          "Rows in the failed batch may or may not have been written — " +
          "re-scan before retrying.",
      };
    }
    onProgress(Math.min(start + chunk.length, rows.length), rows.length);
  }

  return { results, failure: null };
}
